import summaryCommonStore from "@/store/summaryCommon.store";
import addIcon from "@/assets/common/ic_add.svg";
import { useRef } from "react";
import BackTraceList, { BackTraceListRef } from "@/sections/WebSummary/BackTrace/BackTraceList";

const Todo = () => {
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const summaryContentListRef = useRef<BackTraceListRef>(null);

  const handleAddTodo = () => {
    summaryContentListRef.current?.handleAdd();
  };

  return (
    <>
      <div className="mt-1.5 color-#30343C text-3.5 font-normal text-justify select-text lh-7">
        <BackTraceList 
          ref={summaryContentListRef} 
          module="todo" 
          emptyText="暂无待办哦"
          itemClassName="px-2 b-dashed b-b-1.5px b-transparent lh-5.5 text-3.5 color-#30343C rounded-1 border-0 outline-0 resize-none bg-transparent"
        />
      </div>
      {summaryEditing && (
        <div className="cursor-pointer lh-5.5 px-2 py-0.75 rounded-1 mt-2 flex items-center w-fit hover:bg-#F4F6F9" onClick={handleAddTodo}>
          <img src={addIcon} className="size-4 mr-2" />
          <span className="text-3.5 text-mx-quaternary lh-5.5">添加</span>
        </div>
      )}
    </>
  );
};

export default Todo;
